import React from "react";
import "./Frame434.css";

function Frame434(props) {
  const { line36, className } = props;

  return (
    <div className={`frame-43-6 ${className || ""}`}>
      <div className="frame-42-6">
        <div className="group-138-6">
          <div className="payment-methods poppins-normal-tundora-16px">Payment Methods</div>
        </div>
        <img className="vector-10" src="/img/vector-4@2x.png" />
      </div>
      <img className="line-36-3" src={line36} />
    </div>
  );
}

export default Frame434;
